import { jsx } from "react/jsx-runtime";
import React from "react";
var clean_sparkles_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { d: "m18.5012 5.01-.99-3.01-.9899 3.01-3.0101.99 3.0101.99.9899 3.01.99-3.01 3.01-.99-3.01-.99z" }), /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m10.5112 4.4888-2.8166 5.6946L2 13l5.6946 2.8166 2.8166 5.6946 2.8166-5.6946L19.0224 13l-5.6946-2.8166-2.8166-5.6946zm-1.3237 7.1875L10.5112 9l1.3237 2.6763L14.5112 13l-2.6763 1.3237L10.5112 17l-1.3237-2.6763L6.5112 13l2.6763-1.3237z" })];
};
export {
  clean_sparkles_default as default
};
